<template>
  <div id="base-single-template">
    <section class="mr-single">
      <div class="mr-single__inner">
        <div class="mr-single__inner__image">
          <slot name="template-label" />
          <slot name="share-button" />
          <slot name="main-image" />
        </div>
        <div class="mr-single__inner__data">
          <div class="data-info-container">
            <div class="data-info-container__inner">
              <slot name="data-info" />
            </div>
          </div>
          <div
            v-if="$slots['data-info-dark']"
            class="data-info-container data-info-container--dark"
          >
            <div class="data-info-container__inner">
              <slot name="data-info-dark" />
            </div>
          </div>
          <slot name="episodes" />
          <slot name="load-more" />
          <slot name="tracklist" />
          <slot name="artist-section" />
          <slot name="related-section" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'BaseSingleTemplate'
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/templates/_base-single.scss';
</style>
